module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"btn":{"zoomIn":"画像を拡大","pagetop":"ページ上部に戻る"}}}')
  delete Component.options._Ctor
}
